<template>
  <div>
    <page-header
      :actions="headerActionConfig"
      left-side-class="col-xl-4 pb-2"
      :page="page"
      right-side-class="col-xl-8 align-items-end d-flex pb-4 justify-content-end"
    />

    <provider-search-filter
      v-model="filter"
      class="mb-4"
      @search="handleSearch"
    />

    <custom-separator text="Resultados" />

    <div class="d-flex justify-content-end">
      <action-button
        :i="orderIcon"
        text="Ordenar por Nombre"
        variant="success"
        @click="orderByName"
      />
    </div>

    <provider-search-result
      :data="providers"
      @page-changed="pageChanged"
      @per-page-changed="pageChanged"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomSeparator from '@/components/common/CustomSeparator';
import ProviderSearchFilter from './_components/ProviderSearchFilter';
import ProviderSearchResult from './_components/ProviderSearchResult';
import { name } from '@/modules/provider/store';
import { mapState, mapActions } from 'vuex';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import _generalApi from '@/modules/app/api';

const ORDER_DESC = false;

export default {
  name: 'ProviderSearch',
  components: {
    PageHeader,
    CustomSeparator,
    ProviderSearchFilter,
    ProviderSearchResult,
  },
  mixins: [alertMixin],
  data: () => ({
    page: {
      title: 'Proveedores',
      icon: 'orange-icon fas fa-user-tie',
      routes: ['Proveedor', 'Proveedores'],
    },
    filter: {
      company: null,
      status: null,
      companyType: null,
      isActive: null,
      desc: ORDER_DESC,
      page: 1,
    },
    isDescOrder: ORDER_DESC,
  }),
  computed: {
    ...mapState(name, ['providers', 'companyTypes']),
    showAdd() {
      return this.userHasPermissions('providers.add');
    },
    canDownloadReport() {
      return this.userHasPermissions('provider.providersreport.download');
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.go(-1);
          },
          visible: true,
        },
        {
          text: 'Reporte Proveedores',
          icon: 'fas fa-file-download pr-1',
          variant: 'outline-success',
          click: async () =>
            await _generalApi.downloadReport('activeprovidersreport'),
          visible: this.canDownloadReport,
        },
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus pr-1',
          variant: 'success',
          click: this.AddHandler,
          visible: this.showAdd,
        },
      ];
    },
    orderIcon() {
      return this.isDescOrder
        ? 'fas fa-sort-alpha-down-alt'
        : 'fas fa-sort-alpha-down';
    },
  },
  methods: {
    ...mapActions(name, ['searchProviders']),
    handleSearch() {
      const payload = {
        companyId: this.filter.company?.id,
        companyTypeId: this.filter.companyType?.id,
        isActive: this.filter.status?.value,
        desc: this.isDescOrder,
        page: 1,
      };

      this.searchProviders(payload);
    },
    orderByName() {
      this.isDescOrder = !this.isDescOrder;
      const payload = {
        companyId: this.filter.company?.id,
        companyTypeId: this.filter.companyType?.id,
        isActive: this.filter.status?.value,
        desc: this.isDescOrder,
        page: 1,
      };
      this.searchProviders(payload);
    },
    pageChanged(page) {
      const payload = {
        companyId: this.filter.company?.id,
        companyTypeId: this.filter.companyType?.id,
        isActive: this.filter.status?.value,
        desc: this.isDescOrder,
        page: page,
      };
      this.searchProviders(payload);
    },
    AddHandler() {
      if (!this.filter.companyType?.id) {
        this.ShowToast(
          'Error',
          'Debe seleccionar un tipo de proveedor para poder crear uno nuevo.',
          'error'
        );
        return;
      }
      this.$router.push({
        name: 'provider-create',
        params: { companyTypeId: this.filter.companyType?.id },
      });
    },
  },
};
</script>

<style></style>
